$(document).ready(function () {
 // Scroll the home page slide
  setTimeout(function () {
  $(".slider-button--next").trigger("click");
     }, 14000);

   
   $(document).on("click",".categories-main",function() {
        $(".categories-cls").slideToggle(400);
      $(".categories-main").toggleClass("active");
    });
  $(document).on(
    "click",
    "#categories-cls li.nav--has-dropdown span.arrow",
    function () {
      if ($(this).parent("li").hasClass("liactive") == false) {
        $("ul#categories-cls li.nav--has-dropdown span.arrow")
          .removeClass("active")
          .siblings("ul")
          .slideUp()
          .parent("li")
          .removeClass("liactive");
        $(this)
          .addClass("active")
          .siblings("ul")
          .slideDown()
          .parent("li")
          .addClass("liactive");
      } else {
        $("ul#categories-cls li.nav--has-dropdown span.arrow")
          .removeClass("active")
          .siblings("ul")
          .slideUp()
          .parent("li")
          .removeClass("liactive");
      }
    }
  );

  $("input.current_acctive").click(function () {
    $("input.current_acctive").removeClass("border-active");
    $(this).addClass("border-active");
  });
  $("input.size_current_acctive").click(function () {
    $("input.size_current_acctive").removeClass("size_border-active");
    $(this).addClass("size_border-active");
  });

  //product page slick slider
  $('.slider-for').slick({
   slidesToShow: 1,
   slidesToScroll: 1,
   arrows: true,
   asNavFor: '.slider-nav'
 });
 $('.slider-nav').slick({
   slidesToShow: 4,
   slidesToScroll: 1,
   asNavFor: '.slider-for',
   arrows: true,
   vertical: true,
  verticalSwiping: true,
   focusOnSelect: true
 });


  
});
